(function() {
    angular.module('tmx-app').controller('visitReportCtrl', [
        '$mdSidenav',
        'tmxUtility',
        'menu',
        '$mdMedia',
        'BranchService',
        'VisitReportService',

        function VisitReportCtrl(
            $mdSidenav,
            tmxUtility,
            menu,
            $mdMedia,
            BranchService,
            VisitReportService
        ) {
            var VisitReportVM = this;
            VisitReportVM.menu = menu;
            VisitReportVM.gridData = new kendo.data.ObservableArray([]);
    // VisitReportVM.checkPermission = PrivilegesService.checkPermission;
            VisitReportVM.search = search;
            VisitReportVM.filterEnabled = false;
    // VisitReportVM.disableExport = true;
            VisitReportVM.toggle = toggle;
            VisitReportVM.isOpen = isOpen;
            VisitReportVM.formatColumnName = tmxUtility.formatColumnName;
            var exportFromDate=null;
            var exportToDate=null;
    
            VisitReportVM.clear = clear;
            VisitReportVM.formatDateTime=tmxUtility.formatDateTimeForCompany;


            function isOpen(navID) {
                return $mdSidenav(navID).isOpen();
            }
            function clear() {
    //   VisitReportVM.disableExport = true;
                VisitReportVM.LoanApplicationNumber = null;
                VisitReportVM.BranchId=null;
                VisitReportVM.NationalId=null;
                VisitReportVM.FromDate=null;
                VisitReportVM.ToDate=null;
                VisitReportVM.container.VisitReportGrid.dataSource.read();
            }

      
            BranchService.getByAction('GetBranchesByUserCompany',true).then(function(response){
                decorateForSelect(response.data);
                VisitReportVM.Branches=response.data;
            });

            function decorateForSelect(arrayOfObj) {
                arrayOfObj.forEach(
                    function (obj) {
                        obj.LookupId=obj.CompanyBranchId;
                        obj.VisibleValue = obj.BranchName;
                        obj.HiddenValue = obj.BranchCode;
                    }
                );
            }

            function toggle() {
                $mdSidenav("ExportSideNav")
                    .toggle()
                    .then(function() {});
            }

            VisitReportVM.exportToPdf = exportToPdf;

            function search() {
                VisitReportVM.container.VisitReportGrid.dataSource.read();
                VisitReportVM.filterEnabled = true;
                exportFromDate = moment(new Date(VisitReportVM.FromDate)).startOf('day').toISOString().replace(/:/g, '~').replace("Z", "");
                exportToDate = moment(new Date(VisitReportVM.ToDate)).endOf('day').toISOString().replace(/:/g, '~').replace("Z", "");
            }

            function exportToPdf() {
                var fromdate = exportFromDate
                    ? exportFromDate
                    : null;
                var todate = exportToDate
                    ? exportToDate
                    : null;
                VisitReportService.exportVisitReport(fromdate,todate);
            }
            
            VisitReportVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o) {
                            var fromdate='';
                            var todate='';


                            if (VisitReportVM.FromDate) {
                                fromdate = moment(new Date(VisitReportVM.FromDate)).startOf('day').toISOString().replace("Z", "");                            
                            }
                            if (VisitReportVM.ToDate) {
                                todate = moment(new Date(VisitReportVM.ToDate)).endOf('day').toISOString().replace("Z", "");                            
                            }

                            var objArgs = {
                                "FromDate":fromdate,
                                "ToDate":todate
                            };
              
                            var filters = {
                                "StoredProcedure": "sp_visiting_sheet",
                                "Arguments": objArgs,
                                "ReportName": "Visit_Report"
                            };
              

                            VisitReportVM.o = angular.copy(o);
                            VisitReportVM.filters = VisitReportVM.o.data.filter;

                            firebase.logTmxEvent('report',{name:'Visit Report'});

                            VisitReportService.putByParams(o, true, "ReportDataSourceResultPost", filters).then(function (response) {
              
                                if (response) {
                                    VisitReportVM.GridResponseData = response.Data;
                                    o.success(response);
                                }
                            });
  
                            VisitReportVM.filterEnabled = true;
            
                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "data.length",
          // parse: function(response) {
          //   if (response != undefined) {
          //     response = response.data;

          //     var invoices = [];
          //     var invoiceNumber = [];

          //     for (var i = 0; i < response.length; i++) {
          //       var invoice = response[i];

          //       invoice.InvoiceGroup =
          //         invoice.InvoiceGroup +
          //         " -- Date:" +
          //         moment(invoice.InvoiceDate).format("DD/MM/YYYY") +
          //         " -- Customer: " +
          //         invoice.CustomerName +
          //         " -- Status: " +
          //         invoice.ClubbedStatus;
          //       invoice.InvoiceDate = moment(invoice.InvoiceDate).format(
          //         "DD-MM-YYYY"
          //       );

          //       if (!invoiceNumber.includes(invoice.InvoiceNumber)) {
          //         invoices.push(invoice);
          //         invoiceNumber.push(invoice.InvoiceNumber);
          //       }
          //     }


          //     invoices = {
          //       data: invoices
          //     };

          //     return invoices;
          //   }
          // }
                    },
        // aggregate: [
        //   { field: "InvoiceNumber", aggregate: "count" },
        //   { field: "InvoiceLineTax", aggregate: "count" },
        //   { field: "InvoiceTotalAmount", aggregate: "sum" }
        // ],
        // group: {
        //   field: "InvoiceNumber",
        //   aggregates: [
        //     { field: "InvoiceNumber", aggregate: "count" },
        //     { field: "InvoiceLineTax", aggregate: "count" },
        //     { field: "InvoiceTotalAmount", aggregate: "sum" }
        //   ]
        // },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false
        // sort: [{ field: "InvoiceDate", dir: "desc" }]
                },
                pageable: {
                    refresh: true,
                    pageSizes: [5, 10, 15, 20, 100, "All"],
                    pageSize: 15,
                    buttonCount: 4
                },
                excel: {
                    allPages: true,
                    fileName: "VisitReport.xlsx"
                },
                excelExport: function(e) {
                    var sheet = e.workbook.sheets[0];
                    var columns = e.workbook.sheets[0].columns;
                    for (var rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {


                        var row = sheet.rows[rowIndex];
          // console.log(row.cells[8].value);
                        row.cells[8].value = VisitReportVM.formatDateTime(row.cells[8].value);
                        row.cells[7].value = VisitReportVM.formatDateTime(row.cells[7].value);
                    }
                    columns.forEach(function(column) {
                        delete column.width;
                        column.autoWidth = true;
                    });
                },
                sortable: true,
                scrollable: !$mdMedia("gt-sm"),

                columns: VisitReportService.GridColumns
            };
        }]);
})();
